import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { isNotNullOrUndefined } from '@utils/utils';
import COBadge from '@components/FigmaComponents/COBadge.tsx';
import PriceTag from '@components/RingilComponents/tags/priceTag/PriceTag.tsx';
import { PriceDTO } from '@api/ringil-api.v2.tsx';
import { SecuredConfig, useSecuredDecoration } from '@components/security/securedDecoration';

interface ComponentProps {
  priceDto: PriceDTO;
  dataTestId?: string;
  secured?: SecuredConfig;
}

const PiecesBadge: React.FC<ComponentProps> = ({ priceDto, dataTestId, secured }) => {
  const { tr } = useTranslationLgs();
  const { decorate } = useSecuredDecoration(secured);

  return (
    <>
      {decorate(isNotNullOrUndefined(priceDto) && (
        <COBadge variant={'outlined'} type={'info'}>
          <div className="flex flex-row whitespace-nowrap items-center gap-1" data-testid={dataTestId}>
            <div className="text-content-secondary">{tr(`PriceBadge.totalPrice`, `Total price`)}</div>
            <PriceTag
              priceDto={priceDto}
              badgeType={'none'}
            />
          </div>
        </COBadge>
      ))}
    </>
  );
};

export default PiecesBadge;
